
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2108',
  depVersions: {
  "customer-portal-app": "static-1.2108",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.458",
  "data-fetching-client": "static-1.9616",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25194",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5535",
  "hs-test-utils": "static-1.7958",
  "hub-http": "static-1.6163",
  "hub-http-shared-msw-handlers": "static-1.9825",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18062",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11402",
  "I18n": "static-7.1610",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6413",
  "payment-link-components": "static-1.23363",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6941",
  "quartz-core": "static-1.6160",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10153",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5296",
  "rich-text-lib": "static-1.19725",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17899",
  "ui-components-test-utils": "static-1.5540",
  "UIComponents": "static-3.8349",
  "foundations-assets": "static-1.4794",
  "foundations-components": "static-1.7812",
  "foundations-theming": "static-1.4357",
  "foundations-theming-specialty": "static-1.2073",
  "framer-motion": "static-1.70",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.776",
  "quartz-config": "static-1.719",
  "quartz-routing": "static-1.371",
  "quick-fetch": "static-1.3869",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.7",
  "rpc-client-utils": "static-1.4588",
  "sanitize-text": "static-1.8085",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4712",
  "ui-addon-react-router-dom": "static-1.9487",
  "usage-tracker": "static-1.7279",
  "usage-tracker-anonymous": "static-1.5696",
  "usage-tracker-core": "static-1.7129",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3356",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3218",
  "quartz-webpack": "static-1.3165",
  "bend-plugin-quartz-routing": "static-1.19",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7602",
  "frontend-preferences-client": "static-1.7869",
  "laboratory-lib": "static-3.7101",
  "onboarding-scopes": "static-1.6405",
  "ui-addon-opt": "static-4.8318",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3069",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.36",
  "ts-schema": "static-1.4030",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7659",
  "cssUtils": "static-1.778",
  "customer-data-ui-utilities": "static-1.9768",
  "HubStyle": "static-2.11710",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.616",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9830",
  "ui-addon-i18n": "static-1.11093",
  "ui-business-units-lib": "static-1.8988",
  "ui-shepherd-react": "static-3.10090",
  "video-components-external": "static-1.11078",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4267",
  "commerce-tours-lib": "static-1.5982",
  "customer-data-properties": "static-1.51342",
  "getting-started-shared-tasks": "static-1.18334",
  "growth-onboarding-reliability": "static-1.5024",
  "onboarding-tours": "static-1.16483",
  "reference-resolvers-lite": "static-1.8035",
  "sales-checkout-service-client": "static-1.3581",
  "ui-addon-iframeable": "static-1.8995",
  "user-context": "static-1.5043",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4604",
  "icons": "static-2.643",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.616",
  "quartz-head": "static-1.606",
  "quartz-test": "static-1.616",
  "quartz-tracking": "static-1.320",
  "ui-fonts": "static-1.664",
  "usage-tracker-container": "static-1.7269",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9371",
  "data-token-picker": "static-1.16297",
  "FileManagerLib": "static-1.39087",
  "property-translator": "static-1.5345",
  "atom": "static-1.5014",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5774",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5295",
  "react-select-plus": "static-1.103",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-components": "static-1.4081",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "trellis-assets": "static-1.1632",
  "bend-plugin-foundations-theming": "static-1.2840",
  "foundations-theming-base": "static-1.3342",
  "stylex": "static-1.31",
  "interframe": "static-3.4703",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5693",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "chirp-fetch": "static-1.1827",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4415",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3093",
  "inbound-db-properties-service-client": "static-1.3793",
  "superstore": "static-1.4709",
  "feedback-loader": "static-1.29188",
  "ai-components-ui-library": "static-1.8783",
  "ui-addon-video-player": "static-1.8640",
  "ui-coaching-tips": "static-1.28378",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4561",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2438",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8112",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4591",
  "content-media-composition-data-lib": "static-1.12050",
  "content-media-compositions": "static-2.16057",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4096",
  "magpie-lib": "static-1.5521",
  "magpie-types": "static-1.4981",
  "media-bridge-lib": "static-1.18820",
  "video-data-lib": "static-1.34736",
  "commerce-products-lib": "static-1.9306",
  "crm-message-bus": "static-1.42826",
  "growth-data-modal": "static-1.5332",
  "hubspot-apollo-client": "static-1.4819",
  "onboarding-tours-client": "static-1.4697",
  "calling-global-api": "static-1.64297",
  "calling-internal-common": "static-1.31243",
  "calling-lifecycle-internal": "static-1.65679",
  "calling-lifecycle-messages": "static-1.57973",
  "conditional-properties-service-client": "static-1.3749",
  "crm-links": "static-1.6220",
  "customer-data-objects-ui-components": "static-1.12964",
  "customer-data-properties-shared-msw-handlers": "static-1.9152",
  "customer-data-property-utils": "static-1.8025",
  "external-options-client-types": "static-1.4111",
  "file-manager-components": "static-1.23447",
  "framework-data-schema-resolvers": "static-1.6819",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.83",
  "inbound-db-meta-service-client": "static-1.3543",
  "inbounddb-objects-service-types": "static-1.4176",
  "meetings-icalendar-utils-lib": "static-1.573",
  "multi-currency-client-types": "static-1.3644",
  "object-builder-ui-client": "static-1.48538",
  "pipeline-validation-client-types": "static-1.3918",
  "property-value-citations": "static-1.1956",
  "pulse": "static-1.495",
  "smart-property-lib": "static-1.6647",
  "tiered-pricing": "static-1.1080",
  "ui-addon-form-validation": "static-1.10931",
  "growth-onboarding-confetti": "static-1.3010",
  "growth-onboarding-next-action-utils": "static-1.1742",
  "navigation-components": "static-1.17820",
  "onboarding-tours-utils": "static-1.549",
  "ui-shepherd-tracker": "static-1.7471",
  "ui-universal-auth": "static-1.8900",
  "batch-promise": "static-1.1493",
  "navigation-messaging": "static-1.7147",
  "getting-started-shared-tasks-store": "static-1.17452",
  "hubspotter-http-shared-msw-handlers": "static-1.9823",
  "usage-tracker-session-replay": "static-1.4965",
  "audio-components": "static-1.5824",
  "FileManagerCore": "static-1.38946",
  "FileManagerImages": "static-1.36598",
  "video-components": "static-1.13081",
  "foundations-components-legacy": "static-1.837",
  "purchase-motions-api": "static-1.5777",
  "self-service-api": "static-1.10188",
  "signup-constants": "static-1.18736",
  "signup-ui-url-generator": "static-2.7978",
  "trials-service-types": "static-1.3845",
  "usage-tracker-public": "static-1.7090",
  "chatspot-core": "static-1.21001",
  "ContentUtils": "static-1.68185",
  "copilot-toolkit": "static-1.10959",
  "growth-onboarding-feedback-components": "static-1.6526",
  "reactive-lib": "static-1.663",
  "simple-logging-lib": "static-1.2991",
  "commerce-permissions": "static-1.707",
  "customer-data-tracking": "static-1.6828",
  "products-iframe-lib": "static-1.7755",
  "products-ui-components-shared-msw-handlers": "static-1.10207",
  "onboarding-data-sync-lib": "static-1.1857",
  "hubspot-apollo-cache": "static-1.278",
  "calling-error-reporting": "static-1.31249",
  "shared-worker-versioning": "static-1.10979",
  "calling-usage-tracker": "static-1.6484",
  "voice-sms-access-library": "static-1.746",
  "conversations-skeleton-state": "static-1.7191",
  "location-customization-utils-lib": "static-1.9065",
  "crm-pipelines-api-client-types": "static-1.4095",
  "framework-builder-read-service-client": "static-1.3962",
  "framework-data-schema-quick-fetch": "static-1.6724",
  "persist-promise": "static-1.3650",
  "directed-graph": "static-1.878",
  "event-emitter": "static-1.891",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.99",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9908",
  "fsm": "static-1.3675",
  "policy-lib": "static-1.6714",
  "react-tinymce": "static-1.55073",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9971",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54199",
  "tinymce-plugins": "static-1.57313",
  "tinymce-themes": "static-1.56169",
  "growth-onboarding-next-action-components": "static-1.1770",
  "user-context-client": "static-1.4552",
  "nest": "static-1.165",
  "unified-auth-core-lib": "static-1.695",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4474",
  "video-embed": "static-1.35570",
  "content-icons-ui": "static-1.2211",
  "social-insights-client-types": "static-1.21915",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4753",
  "integrations-lib": "static-1.15925",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4206",
  "InboxConnectUtils": "static-4.14634",
  "calling-orchestration-schema": "static-1.35523",
  "crm-record-cards-service-types": "static-1.3563",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4458",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2982",
  "tinymce-data": "static-1.40284",
  "ui-addon-sales-email": "static-1.5152",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12325",
  "layout-dnd-utils": "static-1.11300",
  "react-codemirror": "static-1.10566",
  "ui-brand-identity-lib": "static-1.14973",
  "NamespacedHubStyle": "static-2.9016",
  "outpost": "static-1.4132",
  "flux-actions": "static-1.329",
  "integrations-error-boundary-lib": "static-1.13340",
  "integrations-tracking-lib": "static-1.5538",
  "native-integrations-shared-strings": "static-1.7726",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10314",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.414",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68260",
  "layout-data-lib": "static-1.9625",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2952",
  "google-sheets-integration-lib": "static-1.62",
  "microsoft-drive-integration-lib": "static-1.169",
  "advanced-menus-core": "static-1.15033",
  "advanced-menus-lib": "static-1.11987",
  "ExportDialog": "static-6.10335",
  "ui-memberships-settings-lib": "static-1.33883",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15032",
  "simple-menus-lib": "static-1.16549"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2108",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.458",
  "data-fetching-client": "/data-fetching-client/static-1.9616",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25194",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5535",
  "hs-test-utils": "/hs-test-utils/static-1.7958",
  "hub-http": "/hub-http/static-1.6163",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9825",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18062",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11402",
  "I18n": "/I18n/static-7.1610",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6413",
  "payment-link-components": "/payment-link-components/static-1.23363",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6941",
  "quartz-core": "/quartz-core/static-1.6160",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10153",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5296",
  "rich-text-lib": "/rich-text-lib/static-1.19725",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17899",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5540",
  "UIComponents": "/UIComponents/static-3.8349",
  "foundations-assets": "/foundations-assets/static-1.4794",
  "foundations-components": "/foundations-components/static-1.7812",
  "foundations-theming": "/foundations-theming/static-1.4357",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2073",
  "framer-motion": "/framer-motion/static-1.70",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.776",
  "quartz-config": "/quartz-config/static-1.719",
  "quartz-routing": "/quartz-routing/static-1.371",
  "quick-fetch": "/quick-fetch/static-1.3869",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.7",
  "rpc-client-utils": "/rpc-client-utils/static-1.4588",
  "sanitize-text": "/sanitize-text/static-1.8085",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4712",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9487",
  "usage-tracker": "/usage-tracker/static-1.7279",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5696",
  "usage-tracker-core": "/usage-tracker-core/static-1.7129",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3356",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3218",
  "quartz-webpack": "/quartz-webpack/static-1.3165",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.19",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7602",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7869",
  "laboratory-lib": "/laboratory-lib/static-3.7101",
  "onboarding-scopes": "/onboarding-scopes/static-1.6405",
  "ui-addon-opt": "/ui-addon-opt/static-4.8318",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3069",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.36",
  "ts-schema": "/ts-schema/static-1.4030",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7659",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9768",
  "HubStyle": "/HubStyle/static-2.11710",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.616",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9830",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11093",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8988",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10090",
  "video-components-external": "/video-components-external/static-1.11078",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4267",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5982",
  "customer-data-properties": "/customer-data-properties/static-1.51342",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18334",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5024",
  "onboarding-tours": "/onboarding-tours/static-1.16483",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8035",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3581",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8995",
  "user-context": "/user-context/static-1.5043",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4604",
  "icons": "/icons/static-2.643",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.616",
  "quartz-head": "/quartz-head/static-1.606",
  "quartz-test": "/quartz-test/static-1.616",
  "quartz-tracking": "/quartz-tracking/static-1.320",
  "ui-fonts": "/ui-fonts/static-1.664",
  "usage-tracker-container": "/usage-tracker-container/static-1.7269",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9371",
  "data-token-picker": "/data-token-picker/static-1.16297",
  "FileManagerLib": "/FileManagerLib/static-1.39087",
  "property-translator": "/property-translator/static-1.5345",
  "atom": "/atom/static-1.5014",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5774",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5295",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4081",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "trellis-assets": "/trellis-assets/static-1.1632",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2840",
  "foundations-theming-base": "/foundations-theming-base/static-1.3342",
  "stylex": "/stylex/static-1.31",
  "interframe": "/interframe/static-3.4703",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5693",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "chirp-fetch": "/chirp-fetch/static-1.1827",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4415",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3793",
  "superstore": "/superstore/static-1.4709",
  "feedback-loader": "/feedback-loader/static-1.29188",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8783",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8640",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28378",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4561",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2438",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8112",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4591",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12050",
  "content-media-compositions": "/content-media-compositions/static-2.16057",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4096",
  "magpie-lib": "/magpie-lib/static-1.5521",
  "magpie-types": "/magpie-types/static-1.4981",
  "media-bridge-lib": "/media-bridge-lib/static-1.18820",
  "video-data-lib": "/video-data-lib/static-1.34736",
  "commerce-products-lib": "/commerce-products-lib/static-1.9306",
  "crm-message-bus": "/crm-message-bus/static-1.42826",
  "growth-data-modal": "/growth-data-modal/static-1.5332",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4819",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4697",
  "calling-global-api": "/calling-global-api/static-1.64297",
  "calling-internal-common": "/calling-internal-common/static-1.31243",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65679",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57973",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3749",
  "crm-links": "/crm-links/static-1.6220",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12964",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9152",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8025",
  "external-options-client-types": "/external-options-client-types/static-1.4111",
  "file-manager-components": "/file-manager-components/static-1.23447",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6819",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.83",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3543",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4176",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.573",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3644",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48538",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3918",
  "property-value-citations": "/property-value-citations/static-1.1956",
  "pulse": "/pulse/static-1.495",
  "smart-property-lib": "/smart-property-lib/static-1.6647",
  "tiered-pricing": "/tiered-pricing/static-1.1080",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10931",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3010",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1742",
  "navigation-components": "/navigation-components/static-1.17820",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.549",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7471",
  "ui-universal-auth": "/ui-universal-auth/static-1.8900",
  "batch-promise": "/batch-promise/static-1.1493",
  "navigation-messaging": "/navigation-messaging/static-1.7147",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17452",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9823",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4965",
  "audio-components": "/audio-components/static-1.5824",
  "FileManagerCore": "/FileManagerCore/static-1.38946",
  "FileManagerImages": "/FileManagerImages/static-1.36598",
  "video-components": "/video-components/static-1.13081",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.837",
  "purchase-motions-api": "/purchase-motions-api/static-1.5777",
  "self-service-api": "/self-service-api/static-1.10188",
  "signup-constants": "/signup-constants/static-1.18736",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7978",
  "trials-service-types": "/trials-service-types/static-1.3845",
  "usage-tracker-public": "/usage-tracker-public/static-1.7090",
  "chatspot-core": "/chatspot-core/static-1.21001",
  "ContentUtils": "/ContentUtils/static-1.68185",
  "copilot-toolkit": "/copilot-toolkit/static-1.10959",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6526",
  "reactive-lib": "/reactive-lib/static-1.663",
  "simple-logging-lib": "/simple-logging-lib/static-1.2991",
  "commerce-permissions": "/commerce-permissions/static-1.707",
  "customer-data-tracking": "/customer-data-tracking/static-1.6828",
  "products-iframe-lib": "/products-iframe-lib/static-1.7755",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10207",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1857",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.278",
  "calling-error-reporting": "/calling-error-reporting/static-1.31249",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10979",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6484",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.746",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7191",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9065",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4095",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3962",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6724",
  "persist-promise": "/persist-promise/static-1.3650",
  "directed-graph": "/directed-graph/static-1.878",
  "event-emitter": "/event-emitter/static-1.891",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.99",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9908",
  "fsm": "/fsm/static-1.3675",
  "policy-lib": "/policy-lib/static-1.6714",
  "react-tinymce": "/react-tinymce/static-1.55073",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9971",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54199",
  "tinymce-plugins": "/tinymce-plugins/static-1.57313",
  "tinymce-themes": "/tinymce-themes/static-1.56169",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1770",
  "user-context-client": "/user-context-client/static-1.4552",
  "nest": "/nest/static-1.165",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.695",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4474",
  "video-embed": "/video-embed/static-1.35570",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "social-insights-client-types": "/social-insights-client-types/static-1.21915",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4753",
  "integrations-lib": "/integrations-lib/static-1.15925",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4206",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14634",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35523",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3563",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4458",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2982",
  "tinymce-data": "/tinymce-data/static-1.40284",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5152",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12325",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11300",
  "react-codemirror": "/react-codemirror/static-1.10566",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14973",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9016",
  "outpost": "/outpost/static-1.4132",
  "flux-actions": "/flux-actions/static-1.329",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13340",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5538",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7726",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10314",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.414",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68260",
  "layout-data-lib": "/layout-data-lib/static-1.9625",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2952",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.62",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.169",
  "advanced-menus-core": "/advanced-menus-core/static-1.15033",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11987",
  "ExportDialog": "/ExportDialog/static-6.10335",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33883",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15032",
  "simple-menus-lib": "/simple-menus-lib/static-1.16549"
}
};
